<template>
  <v-container fluid fill-height class="background-gradient">
    <v-row justify="center" no-gutters>
      <v-col xs="11" sm="8" md="6" lg="4">
        <p class="text-center login">BEM-VINDO AO PEJA BAURU</p>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card ref="form" round elevation-3>
            <v-card-text>
              <v-text-field
                v-model="credentials.username"
                :rules="emailRules"
                label="E-mail"
                outlined
                name="email"
                @v-on:keyup.enter="login"
              />

              <v-text-field
                v-model="credentials.password"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="passwordRules"
                :type="show ? 'text' : 'password'"
                name="senha"
                label="Senha"
                hint="Pelo menos 8 caracteres"
                value="Pa"
                outlined
                @click:append="show = !show"
                @v-on:keyup.enter="login"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :large="$vuetify.breakpoint.smAndUp"
                @click="login"
              >
                <span class="login pa-2">Entrar</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { emailRules, passwordRules } from '@/utils/Rules';
// eslint-disable-next-line import/no-cycle
import { login } from '@/services/auth';

export default {
  name: 'Login',
  data: () => ({
    valid: false,
    show: false,
    credentials: {
      username: '',
      password: '',
    },
    emailRules,
    passwordRules,
  }),
  methods: {
    async login() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const { success } = await login(this.credentials);
        if (!success) {
          this.$root.vtoast.show({
            message: 'E-mail ou senha inválidas.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } else {
          this.$root.vtoast.show({
            message: 'Login realizado com sucesso!',
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          this.$router.push('/dashboard');
        }
      }
    },
  },
};
</script>

<style scoped>
.background-gradient {
  background-image: linear-gradient(to right, #ffd194, #70e1f5);
  filter: alpha(opacity=70);
}

.login {
  font-size: 1em;
  letter-spacing: 1px;
  font-weight: 600;
}
</style>
